"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _AlertHelper = require("../../../../helpers/AlertHelper");

var _MessageHelper = _interopRequireDefault(require("../../../../helpers/MessageHelper"));

var _QuizService = require("./QuizService");

var _default = {
  rounds: [],
  preload: function preload(levelId, start, limit, showInternetMissingError) {
    var _this = this;

    return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var loadedRounds;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return (0, _QuizService.getRounds)(levelId, start, limit);

            case 3:
              loadedRounds = _context.sent;
              console.log('successfully got rounds: ', loadedRounds);
              _this.rounds = _this.rounds.concat(loadedRounds);
              return _context.abrupt("return", _promise["default"].resolve(_this.rounds));

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              console.log('error loading rounds', _context.t0);

              if (showInternetMissingError) {
                (0, _AlertHelper.showWideAlertHtml)(_MessageHelper["default"].noMoreRoundsText);
              }

              return _context.abrupt("return", _promise["default"].resolve(_this.rounds));

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9]]);
    }))();
  },
  get: function get(roundId) {
    var returnValue = null;
    this.rounds.forEach(function (round) {
      if (!round.value) {
        throw new Error('something expected is not defined');
      }

      if (round.value.emsId === roundId) {
        returnValue = round.value;
        return true;
      }

      return false;
    });
    return returnValue;
  },
  getByLevelAndNumber: function getByLevelAndNumber(levelId, roundNumber) {
    var returnValue = null;
    this.rounds.some(function (round) {
      if (!round.value) {
        throw new Error('something expected is not defined');
      }

      if (round.value.level === levelId && round.value.number === roundNumber) {
        returnValue = round.value;
        return true;
      }

      return false;
    });

    if (returnValue === null) {
      console.log("WARNING: did not find round with level: ".concat(levelId, " and number: ").concat(roundNumber));
    }

    return returnValue;
  }
};
exports["default"] = _default;